import * as React from 'react';
import './index.css';
import SlideUpModal from '../SlideUpModal';

const LEFT = 1;
const RIGHT = 2;

interface Props {
  isModelShow: boolean; // 弹窗是否展示
  mainTitle?: string; //主标题
  subTitle: string; //副标题
  leftBtnText?: string; //左侧按钮文案
  rightBtnText: string; //右侧按钮文案
  onClickLeftBtn?: () => void; //左侧按钮点击函数
  onClickRightBtn: () => void; //右侧按钮点击函数
  onClickClose: () => void; //点击叉号关闭弹窗函数
  subTitleMaxLine?: number;
  titleMaxLines?: number;
  buttonStyle?: string; // topBottom: 按钮为上下按钮 默认为左右按钮
}

export default class CommonBottomDialog extends React.Component<Props> {
  onClickBtn = (btn: number) => {
    if (btn === LEFT) {
      this.props.onClickLeftBtn?.();
    } else if (btn === RIGHT) {
      this.props.onClickRightBtn?.();
    }
  };

  render() {
    const {
      mainTitle,
      subTitle,
      isModelShow,
      leftBtnText,
      rightBtnText,
      onClickClose,
      subTitleMaxLine = 3,
      titleMaxLines = 3,
      buttonStyle
    } = this.props;

    return (
      <SlideUpModal
        slideUpModalStatus={isModelShow}
        closeSlideUpModal={onClickClose}
      >
        <view
          className="dialog-mask"
          onClick={() => {
            //do noting 防止点击内容区域弹窗消失
          }}
        >
          <view className="close-area" onClick={onClickClose}>
            <view className="close-area-icon-wrapper">
              <image
                className="close-area-icon"
                src="assets://shop/multi_sku_close_icon.png"
              />
            </view>
          </view>
          <view className="dialog-container">
            <view className="title-content">
              {
                mainTitle ? (
                  <view className="main-title-container">
                    <text className="main-title" content={mainTitle} style={{ maxLines: titleMaxLines }} />
                  </view>
                ) : null
              }
              {
                subTitle ? (
                  <view className="sub-title-container">
                    <text className="sub-title" content={subTitle} style={{ maxLines: subTitleMaxLine }} />
                  </view>
                ) : null
              }
            </view>
            <view className="split-line" />
            {buttonStyle === 'topBottom' ? (
              <view className="dialog-button-container top-bottom">
                {rightBtnText && (
                  <text
                    className="dialog-button dialog-button-right"
                    content={rightBtnText}
                    onClick={() => this.onClickBtn(RIGHT)}
                  />
                )}
                {leftBtnText && (
                  <text className="dialog-button diglog-button-top-bottom" content={leftBtnText} onClick={() => this.onClickBtn(LEFT)} />
                )}
              </view>
            ) : (
              <view className="dialog-button-container">
                {leftBtnText && (
                  <text className="dialog-button" content={leftBtnText} onClick={() => this.onClickBtn(LEFT)} />
                )}
                {leftBtnText && rightBtnText ? <view className="gap" /> : null}
                {rightBtnText && (
                  <text
                    className="dialog-button dialog-button-right"
                    content={rightBtnText}
                    onClick={() => this.onClickBtn(RIGHT)}
                  />
                )}
              </view>
            )}
          </view>
        </view>
      </SlideUpModal>
    );
  }
}
